module.exports = __webpack_public_path__ + "img/NoPath@2x.a864d4e6.png";